import React, { Component } from "react";
import PropTypes from 'prop-types';

import moment from "moment";

import ParadigmaTable from "../../components/ParadigmaTable/";
import DateFilter from "../../components/ParadigmaTable/DateFilter";
import Modal from "./Modal.js";

import { getReadableTipoPedido, getUrlMisPedidosTipoPedido } from "./enums.js";

class HistorialPedidosProducto extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    static propTypes = {
        tipo_pedido: PropTypes.string.isRequired, // Ver enums.js en esta carpeta para saber cuales son los posibles valores
    }

    render() {
        const { tipo_pedido } = this.props;

        // Mismas columnas que el historial de viandas, menos las dos que son
        // propias de la vianda: el rol del usuario en el pedido (un pedido de
        // producto lo hace una sola persona) y el menu diario.
        const columns = [
                {
                    Header: "id",
                    id: "id",
                    accessor: "id",
                    width: 100,
                    show: false,
                    private: true,
                },
                {
                    Header: "Código Verificación",
                    id: "codigo_verificacion",
                    accessor: "codigo_verificacion",
                    show: true,
                    lookup: "icontains",
                    filterable: true,
                },
                {
                    Header: "Orden",
                    id: "orden",
                    accessor: "orden",
                    show: true,
                    filterable: true,
                },
                {
                    Header: "Fecha",
                    id: "fechaCreacion",
                    accessor: (d) => moment(d.fechaCreacion).format("DD/MM/YYYY"),
                    width: 120,
                    className: "text-center",
                    show: true,
                    // Sin `lookup`: el DateFilter manda el suyo junto con el
                    // valor (date, date__gt o date__lt segun lo que se elija en
                    // el popover). datetime porque fechaCreacion guarda la hora
                    // y los lookups tienen que ir contra la fecha sola.
                    Filter: ({ filter, onChange }) =>
                        <DateFilter filter={filter} onChange={onChange} datetime />,
                },
                {
                    Header: "Estado",
                    id: "estado_nombre",
                    accessor: "estado_nombre",
                    show: true,
                    filterable: true,
                },
            ];

        // El pedido mas reciente primero, igual que en el historial de viandas.
        let outerSort = [];

        outerSort.push({
            id: 'fechaCreacion',
            desc: true
        })

        // Cada categoria tiene su endpoint: el backend fija el tipo de pedido y
        // acota las filas a la persona del usuario del request, asi que no hace
        // falta mandar ni la persona ni el tipo como filtro.
        const apiUrl = getUrlMisPedidosTipoPedido(tipo_pedido);

        return (
            <ParadigmaTable
                buttons={[
                    {
                        edit: true,
                        component: (props) => (
                            <Modal {...props} action="DETAIL" tipo_pedido={tipo_pedido} />
                        ),
                        // Sin permission: son las filas del propio usuario, el
                        // backend ya no devuelve las de nadie mas.
                    },
                ]}
                apiUrl={apiUrl}
                columns={columns}
                exportUrl={apiUrl}
                outerSort={outerSort}
                defaultPageSize={21}
                title={'Historial de Pedidos de ' + getReadableTipoPedido(tipo_pedido)}
            />
        )
    }
}

export default HistorialPedidosProducto;



// WEBPACK FOOTER //
// ./src/views/PedidosProducto/HistorialPedidosProducto.js